import React from 'react';
import { formatLocation } from '../../util/mapbox';
import css from './BusinessInfoBlock.module.css';

/**
 * BusinessInfoBlock
 *
 * Renders the seller's business info: name (H1), address, website, phone,
 * and conditional "Lid van" / "Dealer van" fields.
 * CTA buttons ("Stuur een bericht" / "Bel nu") are rendered here as placeholders;
 * their functionality is wired up in subsequent tasks.
 *
 * All fields come from the seller's Sharetribe publicData:
 *   companyWebsite, businessAddress, phoneNumber, lidVan, dealerVan
 */
const BusinessInfoBlock = props => {
  const { displayName, publicData = {}, metadata = {}, onContactClick } = props;

  const { companyWebsite, businessAddress, phoneNumber, lidVan, dealerVan } = publicData;
  const { showResponseTime } = metadata;

  const addressObj = businessAddress?.address;
  const city = addressObj ? formatLocation(addressObj) : null;
  const postCode = addressObj?.postCode || null;
  const addressLine = city ? (postCode ? `${city} ${postCode}` : city) : null;

  return (
    <div className={css.businessInfoBlock}>
      {/* Left column: name + details */}
      <div className={css.businessInfoLeft}>
        <h1 className={css.businessName}>{displayName}</h1>

        <ul className={css.businessDetailsList}>
          {addressLine && (
            <li className={css.businessDetailsItem}>
              <span className={css.businessDetailsLabel}>Locatie: </span>
              {addressLine}
            </li>
          )}

          {companyWebsite && (
            <li className={css.businessDetailsItem}>
              <span className={css.businessDetailsLabel}>Website: </span>
              <a
                href={
                  companyWebsite.startsWith('http') ? companyWebsite : `https://${companyWebsite}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className={css.businessWebsiteLink}
              >
                {companyWebsite.replace(/^https?:\/\//, '')}
              </a>
            </li>
          )}

          {phoneNumber && (
            <li className={css.businessDetailsItem}>
              <span className={css.businessDetailsLabel}>Tel. </span>
              {phoneNumber}
            </li>
          )}

          {lidVan && (
            <li className={css.businessDetailsItem}>
              <span className={css.businessDetailsLabel}>Lid van: </span>
              {lidVan}
            </li>
          )}

          {dealerVan && (
            <li className={css.businessDetailsItem}>
              <span className={css.businessDetailsLabel}>Dealer van: </span>
              {dealerVan}
            </li>
          )}
        </ul>
      </div>

      {/* Right column: CTAs + response time */}
      <div className={css.businessInfoCtas}>
        <button type="button" className={css.ctaSendMessage} onClick={onContactClick}>
          Stuur een bericht
        </button>

        {phoneNumber && (
          <a href={`tel:${phoneNumber}`} className={css.ctaCallNow}>
            Bel nu
          </a>
        )}

        {showResponseTime && (
          <p className={css.responseTime}>Reageert meestal binnen 2 werkdagen</p>
        )}
      </div>
    </div>
  );
};

export default BusinessInfoBlock;
